module.exports = __webpack_public_path__ + "media/D2 Plaza 11.25d848c3.mp3";